import { type } from './type.js';

/**
 * @description
 * Checks if `value` is an `File`
 *
 * @example
 * ``` ts
 * const file = new File(['content'], 'filename.txt', { type: 'text/plain' });
 * isFile(file);
 * // => true
 * isFile('filename.txt');
 * // => false
 * ```
 *
 * @param value value The value to check.
 * @returns Returns `true` if `value` is an File object, else `false`.
 *
 * @docsCategory preference/lang
 * @codeFilter is-file
 */
export const isFile = (value): value is File => {
  return type(value) === 'file';
};
